'use client'
import React, { ReactElement } from 'react'
import { MultiValueProps } from 'react-select'
import { Tag } from '../../../atoms'
import { SelectOption } from '../../../../types/SelectInput'

export const MultiValueComponent = (props: MultiValueProps<SelectOption>): ReactElement => (
    <Tag
        removable={props.isMulti && !props.selectProps.isDisabled && !props.data?.disabled}
        removeClickCallback={props.removeProps.onClick}
        removeMouseDownCallback={props.removeProps.onMouseDown}
        removeTouchEndCallback={props.removeProps.onTouchEnd}
        data-testid="select-input-tag"
    >
        {props.data.label}
    </Tag>
)
